var _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#1B49EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55219 14.7461C8.48146 15.1608 8.44571 15.5807 8.44531 16.0013H10.0001C10.0008 15.6219 10.0379 15.2433 10.1109 14.871C9.58944 14.8412 9.07025 14.8021 8.55219 14.7461Z",
    fill: "#1B49EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69141 11.8672C9.33884 12.3972 9.05531 12.9701 8.84766 13.5718C9.38484 13.6281 9.92428 13.6621 10.4646 13.6883C10.6238 13.3135 10.8211 12.956 11.0532 12.6215C10.5946 12.3783 10.1407 12.1269 9.69141 11.8672Z",
    fill: "#1B49EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8404 11.3227C21.1669 10.4736 20.3173 9.78056 19.3502 9.29141C18.383 8.80226 17.3213 8.5286 16.2382 8.48931C15.1551 8.45001 14.0763 8.646 13.0763 9.06378C12.0762 9.48156 11.1786 10.1112 10.4453 10.9093C10.912 11.1752 11.3828 11.4333 11.8578 11.6838C12.4661 11.103 13.1908 10.6579 13.9839 10.3778C14.7771 10.0977 15.6206 9.98907 16.4588 10.0591C17.297 10.129 18.1108 10.3761 18.8465 10.7838C19.5822 11.1915 20.2231 11.7507 20.7267 12.4244L19.0364 14.0947H23.5583V9.6251L21.8404 11.3227Z",
    fill: "#1B49EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4493 17.4349C23.52 17.0202 23.5558 16.6003 23.5562 16.1797H22.0014C22.0007 16.5592 21.9636 16.9378 21.8906 17.3103C22.4121 17.3404 22.9312 17.3787 23.4493 17.4349Z",
    fill: "#1B49EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3071 20.3133C22.6598 19.7833 22.9433 19.2104 23.1509 18.6086C22.6137 18.5524 22.0743 18.5186 21.534 18.4922C21.3748 18.867 21.1775 19.2245 20.9453 19.559C21.4039 19.8025 21.8579 20.054 22.3071 20.3133Z",
    fill: "#1B49EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1632 20.856C10.8367 21.7051 11.6863 22.3982 12.6535 22.8873C13.6207 23.3765 14.6824 23.6501 15.7655 23.6894C16.8486 23.7287 17.9274 23.5326 18.9274 23.1148C19.9275 22.697 20.8251 22.0673 21.5583 21.2691C21.0916 21.0033 20.6208 20.745 20.1459 20.4943C19.5375 21.0749 18.813 21.52 18.02 21.8C17.227 22.08 16.3837 22.1886 15.5456 22.1187C14.7076 22.0488 13.8939 21.8019 13.1583 21.3944C12.4226 20.9869 11.7818 20.428 11.2781 19.7546L12.9684 18.084H8.44531V22.5536L10.1632 20.856Z",
    fill: "#1B49EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCRefresh);
export default __webpack_public_path__ + "static/media/C_refresh.e5f11bbb8ff066a647e77d5ec0551d80.svg";
export { ForwardRef as ReactComponent };